import { get } from '@/src/shared/api'
import { API_URL } from '@/src/shared/config'

export const eventApi = {
  fetchEvent: get(`${API_URL}/landing`),
  fetchEvents: get(`${API_URL}/landing`),
  fetchLatestEvent: get(`${API_URL}/landing/last`),
}
